import { render, staticRenderFns } from "./PartnerSpotlight.vue?vue&type=template&id=526b7e4a&scoped=true"
import script from "./PartnerSpotlight.vue?vue&type=script&lang=js"
export * from "./PartnerSpotlight.vue?vue&type=script&lang=js"
import style0 from "./PartnerSpotlight.vue?vue&type=style&index=0&id=526b7e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b7e4a",
  null
  
)

export default component.exports